import React from 'react';
import { Breadcrumb } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const ApprovalCenter: React.FC = () => {
  const navigate = useNavigate();

  // 自动重定向到发起申请页面
  React.useEffect(() => {
    navigate('/workbench/application-submission');
  }, [navigate]);

  return (
    <div className="page-container full-height">
      {/* 面包屑导航 */}
      <Breadcrumb style={{ marginBottom: '16px' }}>
        <Breadcrumb.Item>
          <HomeOutlined />
          <span>首页</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item>工作台</Breadcrumb.Item>
        <Breadcrumb.Item>审批中心</Breadcrumb.Item>
      </Breadcrumb>

      <div className="page-header">
        <h1 className="page-title">审批中心</h1>
        <p className="page-subtitle">正在跳转到新的审批功能...</p>
      </div>
    </div>
  );
};

export default ApprovalCenter;